import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {FlowBasicState} from '@gongxigames/framework/slot/modules/flow/states/FlowBasicState';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow/FlowModuleEvents';
import {BigWinEvents} from '@gongxigames/framework/slot/modules/bigwin';
import {WinPresentationEvents} from '@gongxigames/framework/slot/modules/winpresentation';
import {FlowModule} from '@gongxigames/framework/slot/modules/flow/FlowModule';

export class FlowRespinState extends FlowBasicState {

    public onEnterState(): void {
    }

    public onLeaveState(): void {
    }

    protected setupEvents(): void {
        this.setEventHandler(ReelsEvents.SPIN_ENDED, this.onAllReelsStopped.bind(this));
    }

    protected onAllReelsStopped(): void {
        this.clearEventsQueue();

        switch (this.module.logic.nextAction) {
            case Action.SPIN: {
                this.emit(FlowModuleEvents.NO_RESPIN_ON_NEXT_SPIN);
                this.setupLinesWinMainGameSequence();
                break;
            }

            case Action.RESPIN: {
                this.setupRespin();
                break;
            }

            case Action.FREESPIN: {
                throw new Error('Impossible state');
            }

            default:

                break;
        }
    }

    protected setupBigWin(): void {
        super.setupBigWin();

        this.addCallbackToWaitingLIst(BigWinEvents.FINISHED, this.gotoBasicState.bind(this));
    }

    protected setupWin(): void {
        super.setupWin();

        this.addCallbackToWaitingLIst(WinPresentationEvents.INITIAL_ANIMATION_FINISHED, this.gotoBasicState.bind(this));
    }

    protected setupNoWin(): void {
        this.emit(FlowModuleEvents.NO_WIN);
        this.emit(FlowModuleEvents.CAN_SPIN);

        this.gotoBasicState();
    }

    protected gotoBasicState(): void {
        this.module.gotoState(FlowModule.BASIC_STATE);
    }
}
